import { render } from "./LookbookCoverEdit.vue?vue&type=template&id=e9ca6604"
import script from "./LookbookCoverEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LookbookCoverEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Sales/Lookbook/LookbookCoverEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9ca6604"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9ca6604', __exports__)) {
    api.reload('e9ca6604', __exports__)
  }
  
  module.hot.accept("./LookbookCoverEdit.vue?vue&type=template&id=e9ca6604", () => {
    api.rerender('e9ca6604', render)
  })

}


export default __exports__